export default "__VITE_ASSET__BdC_gp0I__"